(function ($, ko) {
    /* Knockout line-grid component.
    Usage:
    <line-grid params="data: [ko.observable | ko.observableArray], pageSize: [number]">
        ... inline template which will be repeated in <div class="claims-bl_sheet"><div> block.
    </line-grid>
    */

    ko.components.register('line-grid', {
        template: '<!-- ko if: !isEmpty() -->' +
            '<div class="claims-bl_sheet" data-bind="foreach: displayedData">' +
            '<!-- ko template: { nodes: $componentTemplateNodes, data: $data } --><!-- /ko -->' +
            '</div>' +
            '<div class="pager">' +
            `<div class="pager_num"><p data-bind="translationHandler: 'filter.Page'">Page</p> <strong data-bind="text: currentPageIndex() + 1"></strong> <p data-bind="translationHandler: 'filter.of'">of</p> <strong data-bind="text: lastPageIndex() + 1"></strong></div>` +
            '<button type="button" class="pager_prev" aria-label="Previous page" data-bind="click: currentPageIndex() > 0 ? prevPage : noop, css: { inactive: currentPageIndex() <= 0 }, attr: { disabled: currentPageIndex() <= 0 }"></button>' +
            '<button type="button" class="pager_next" aria-label="Next page" data-bind="click: currentPageIndex() < lastPageIndex() ? nextPage : noop, css: { inactive: currentPageIndex() >= lastPageIndex() }, attr: { disabled: currentPageIndex() >= lastPageIndex() }"></button>' +
            '<div class="pager_all"><a href="" data-bind="click: showAll, visible: showAllVisible, translationHandler:\'link.show-all\'">show all</a></div>' +
            '</div>' +
            '<!-- /ko -->' +
            '<!-- ko ifnot: !isEmpty() -->' +
            '<div class="b-empty-list">' +
            '<div class="b-empty-list-msg" data-bind="text: message"></div>' +
            '</div>' +
            '<!-- /ko -->',
        viewModel: function (params) {
            var defaults = {
                pageSize: 4,
                data: ko.observable([]),
                isDataLoading: ko.observable(true),
                displayedDataSubscription: function() {},
                makeAvailableItems: function() {}
            };

            var o = $.extend(true, defaults, params);
            var pageSize = ko.observable(o.pageSize);

            if (o.currentPageIndex) {
                this.currentPageIndex = $.isFunction(o.currentPageIndex) ? o.currentPageIndex : ko.observable(o.currentPageIndex);
            } else {
                this.currentPageIndex = ko.observable(0);
            }

            this.displayedData = ko.computed(function () {
                var skip = this.currentPageIndex() * pageSize();
                return o.data().slice(skip, skip + pageSize());
            }, this);

            this.isEmpty = ko.computed(function () {
                return o.isDataLoading() === false && o.data().length === 0;
            }, this);

            this.message = o.messageIfEmpty ? o.messageIfEmpty : $.cdh.languageConstant.getConstant('extension-validation.no-data');

            o.displayedDataSubscription(this.displayedData());
            this.displayedData.subscribe(o.displayedDataSubscription);

            this.showAllVisible = ko.pureComputed(function () {
                return !$.cdh.helper.ieBrowser() && this.lastPageIndex() > 0;
            }, this);

            this.lastPageIndex = ko.pureComputed(function () {
                if (this.isEmpty())
                    return 0;

                return Math.ceil((o.data().length / pageSize()) || 1) - 1;
            }, this);

            this.lastPageIndex.subscribe(function (lastIndex) {
                if (this.currentPageIndex() > lastIndex)
                    this.currentPageIndex(lastIndex);
            }, this);

            this.nextPage = function () {
                this.currentPageIndex(this.currentPageIndex() + 1);
                o.makeAvailableItems(true);
            };

            this.prevPage = function () {
                this.currentPageIndex(this.currentPageIndex() - 1);
                o.makeAvailableItems(true);
            };

            this.showAll = function () {
                pageSize(1000000);
                o.makeAvailableItems(true);
            };

            this.noop = function () {
                o.makeAvailableItems(true);
            };

            o.makeAvailableItems();

            if (params.initialized != null)
                params.initialized(this);
        }
    });

    ko.components.register('load-status', {
        template: { element: 'load-status-template' },
        viewModel: function (params) {
            $.extend(true, this, params );
        }
    });

    ko.components.register('validation-status', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": hasErrors() ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: hasErrors -->" +
            "<span data-bind='text: requiredMessage'>" +
            "<br data-bind='visible: additionMessage' /><em data-bind='visible: additionMessage, text: additionMessage'></em>" +
            "</span>" +
            "<!-- /ko -->" +
            "</div>",
        viewModel: function (params) {
            $.extend(true, this, $.extend(true, params.validation, {
                invalidRequiredFields: ko.observable([]),
                invalidRequiredFieldsLabelText: ko.observable(''),
                additionMessage: ko.observable(params.additionMessage ? params.additionMessage() : ''),
                toBeTranslated: ko.observable(params.translation ? params.translation() : true)
            }));

            this.requiredMessage = ko.computed(() => {
                if (this.toBeTranslated()) {
                    return $.cdh.languageConstant.getConstant('messages.fill-required-fields');
                }
                else {
                    return $.cdh.languageConstant.getResource('messages.fill-required-fields', 'en');
                }
            });

            this.errorsList.subscribe((v) => {
                setTimeout(() => {
                    const $errorTitle = $('.popup-form_error-title');
                    let $form = $errorTitle.closest('form');
                    if (!$form.length) {
                        $form = $errorTitle.closest('.popup-form');
                    }
                    const $inputs = $form.find('input, textarea, select');
                    const labelMaxLen = 25;
                    const truncate = (str) => str.substring(0, labelMaxLen) + (str.length > labelMaxLen ? '...' : '');
                    const invalidRequiredFields = $inputs.toArray().map((input) => {
                        const $input = $(input);
                        const labelId = $input.attr('aria-labelledby');
                        const errorId = $input.attr('aria-describedby');
                        const label = labelId ? $('#' + labelId).text().trim() : ($input.attr('aria-label') || null);
                        const isVisuallyRequired = label && label.endsWith('*');
                        const isRequired = $input.is('[required]') || isVisuallyRequired;
                        const isInvalid = errorId ? $('#' + errorId.split(' ')[0]).find('.popup-row_inp-error').length > 0 : false;

                        if (isRequired && isInvalid) {
                            if (isVisuallyRequired) {
                                return truncate(label.slice(0, -1).trim());
                            }

                            return truncate(label);
                        }

                        // TODO: handle non-required errors?

                        return null;

                    }).filter(Boolean);

                    this.invalidRequiredFields(invalidRequiredFields);
                    this.invalidRequiredFieldsLabelText(this.invalidRequiredFields().join(', '));

                }, 10);
            });

        }
    });

    ko.components.register('enrollment-validation-status', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": hasErrors() ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: hasErrors() || additionMessage() -->" +
            "<span data-bind='text: fullErrorMessage'></span>" +
            "<!-- /ko -->" +
            "</div>",
        viewModel: function (params) {
            $.extend(true, this, $.extend(true, params.validation, {
                invalidRequiredFields: ko.observable([]),
                invalidRequiredFieldsLabelText: ko.observable(''),
                additionMessage: params.additionMessage || ko.observable(''),
                toBeTranslated: ko.observable(params.translation ? params.translation() : true)
            }));
            this.fullErrorMessage = ko.computed(() => {
                const fillRequired = $.cdh.languageConstant.getConstant('messages.fill-required-fields');
                const addition = this.additionMessage && this.additionMessage();
                if (this.hasErrors && this.hasErrors()) {
                    return addition ? fillRequired + " " + addition : fillRequired;
                }
                return addition || "";
            });
            this.errorsList.subscribe((v) => {
                setTimeout(() => {
                    const $errorTitle = $('.popup-form_error-title');
                    let $form = $errorTitle.closest('form');
                    if (!$form.length) {
                        $form = $errorTitle.closest('.popup-form');
                    }
                    const $inputs = $form.find('input, textarea, select');
                    const labelMaxLen = 25;
                    const truncate = (str) => str.substring(0, labelMaxLen) + (str.length > labelMaxLen ? '...' : '');
                    const invalidRequiredFields = $inputs.toArray().map((input) => {
                        const $input = $(input);
                        const labelId = $input.attr('aria-labelledby');
                        const errorId = $input.attr('aria-describedby');
                        const label = labelId ? $('#' + labelId).text().trim() : ($input.attr('aria-label') || null);
                        const isVisuallyRequired = label && label.endsWith('*');
                        const isRequired = $input.is('[required]') || isVisuallyRequired;
                        const isInvalid = errorId ? $('#' + errorId.split(' ')[0]).find('.popup-row_inp-error').length > 0 : false;

                        if (isRequired && isInvalid) {
                            if (isVisuallyRequired) {
                                return truncate(label.slice(0, -1).trim());
                            }

                            return truncate(label);
                        }
                        return null;

                    }).filter(Boolean);

                    this.invalidRequiredFields(invalidRequiredFields);
                    this.invalidRequiredFieldsLabelText(this.invalidRequiredFields().join(', '));

                }, 10);
            });

        }
    });

    ko.components.register('validation-status2', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": validation.hasErrors() ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: validation.hasErrors -->" +
            "<span data-bind='text: message'></span>" +
            "<!-- /ko -->" +
            "</div>",
        viewModel: function (params) {
            var message = $.cdh.languageConstant.getConstant('extension-validation.please-correct-highlighted');
            if (params.message) {
                message = params.message;
            }
            $.extend(true, this, { validation: params.validation, message: message });
        }
    });


    ko.components.register('validation-status3', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": hasErrors() ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: hasErrors -->" +
            "<span>Enter Zip code to see the results<em data-bind='visible: invalidRequiredFieldsLabelText'>: </em><em data-bind='text: invalidRequiredFieldsLabelText'></em>" +
            "<br data-bind='visible: additionMessage' /><em data-bind='visible: additionMessage, text: additionMessage'></em>" +
            "</span>" +
            "<!-- /ko -->" +
            "</div>",
        viewModel: function (params) {
            $.extend(true, this, $.extend(true, params.validation, {
                invalidRequiredFields: ko.observable([]),
                invalidRequiredFieldsLabelText: ko.observable(''),
                additionMessage: ko.observable(params.additionMessage ? params.additionMessage() : '')
            }));

            this.errorsList.subscribe((v) => {
                setTimeout(() => {
                    const $errorTitle = $('.popup-form_error-title');
                    let $form = $errorTitle.closest('form');
                    if (!$form.length) {
                        $form = $errorTitle.closest('.popup-form');
                    }
                    const $inputs = $form.find('input, textarea, select');
                    const labelMaxLen = 25;
                    const truncate = (str) => str.substring(0, labelMaxLen) + (str.length > labelMaxLen ? '...' : '');
                    const invalidRequiredFields = $inputs.toArray().map((input) => {
                        const $input = $(input);
                        const labelId = $input.attr('aria-labelledby');
                        const errorId = $input.attr('aria-describedby');
                        const label = labelId ? $('#' + labelId).text().trim() : ($input.attr('aria-label') || null);
                        const isVisuallyRequired = label && label.endsWith('*');
                        const isRequired = $input.is('[required]') || isVisuallyRequired;
                        const isInvalid = errorId ? $('#' + errorId.split(' ')[0]).find('.popup-row_inp-error').length > 0 : false;

                        if (isRequired && isInvalid) {
                            if (isVisuallyRequired) {
                                return truncate(label.slice(0, -1).trim());
                            }

                            return truncate(label);
                        }

                        // TODO: handle non-required errors?

                        return null;

                    }).filter(Boolean);

                    this.invalidRequiredFields(invalidRequiredFields);
                    this.invalidRequiredFieldsLabelText(this.invalidRequiredFields().join(', '));
                }, 10);
            });

        }
    });


    ko.components.register('validation-message-row', {
        template:
            "<!-- ko if: validationActivated() && !isValid() -->" +
            "<div class='popup-row_inp-error clearfix' data-bind='css: cssClass'>" +
            "<div  aria-live='polite'>" + "</div>" +
            "<span data-bind='text: error'></span>" +
            "</div>" +
            "<!-- /ko -->",
        viewModel: function (params) {
            this.validationActivated = params.validation.activated;
            this.isValid = params.messageFor.isValid;
            this.error = params.messageFor.error;
            if (params.cssClass) {
                this.cssClass = params.cssClass;
            } else {
                this.cssClass = '';
            }
        }
    });

    ko.components.register('validation-message-box', {
        template:
            "<!-- ko if: validationActivated() && !isValid() -->" +
            "<div class='popup-row_inp-error box clearfix'>" +
            "<span data-bind='text: error'></span>" +
            "</div>" +
            "<!-- /ko -->",
        viewModel: function (params) {
            this.validationActivated = params.validation.activated;
            this.isValid = params.messageFor.isValid;
            this.error = params.messageFor.error;
        }
    });

    ko.components.register('loading-error', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": (!isEmployee || !maintenance()) && error() ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: (!isEmployee || !maintenance()) && error() -->" +
            "<p><span aria-live='assertive' data-bind='translationHandler:\"messages.api-fail-error\"'>We encountered an error.</span></p>" +
            "<p><span data-bind='html: errorMessage()' aria-live='assertive'></span></p>" +
            "<!-- /ko -->" +
            "</div>",
        viewModel: function (params) {

            this.error = params.request.error;
            this.errorMessage = ko.pureComputed(function () {
                const errorData = this.error() ? decodeURIComponent(this.error().replace(/\+/g, ' ')) : null;
                if (params.htmlDecode !== undefined && params.htmlDecode){
                    return $.cdh.helper.htmlDecode (errorData);
                }
                return errorData;
            }, this);

            this.maintenance = $.cdh.global.maintenance;
            this.isEmployee = $.cdh.user.isEmployee;
        }
    });

    ko.components.register('user-impersonated-error', {
        template:
            "<div class='popup-form_error-title' role='alert' data-bind='attr: { \"aria-live\": $.cdh.user.impersonated ? \"assertive\" : \"off\" }'>" +
            "<!-- ko if: $.cdh.user.impersonated -->" +
            `<span aria-live='assertive'>${$.cdh.languageConstant.getConstant('messages.user-impersonated-error')}</span>` +
            "<!-- /ko -->" +
            "</div>"
    });


    // adds 'opened', 'toggleClick', 'onMouseOver' and 'onMouseOut'
    var touchFiendlyToggle = function () {
        var isTouchScreen = ('ontouchend' in window);
        var opened = ko.observable(false);
        let closeTimer;

        this.opened = opened;
        this.toggleClick = function () {
            if (ko.unwrap(this.disable)) return;
            opened(!opened());
            // IMPORTANT: DO NOT prevent default and stop propogation. It will break existing components.
        };
        this.onMouseOver = function () {
            if (isTouchScreen) return;
            if (ko.unwrap(this.disable)) return;
            clearTimeout(this.closeTimer);
            opened(true);
        };
        this.onMouseOut = function () {
            if (isTouchScreen) return;
            if (ko.unwrap(this.disable)) return;
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(function () {
                opened(false);
            }, 100);
        };

        var closeEvent = 'click.' + Math.random().toString().substring(2);
        opened.subscribe(function (isOpened) {
            isOpened
                ? setTimeout(function () {
                    $(window).on(closeEvent, opened.bind(null, false));
                }, 0)
                : $(window).off(closeEvent);
        });
    }

    this.selectManager = function (data, e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.toggleClick();
        }
    }

    ko.components.register('filter-setter', {
        template: { element: 'template-filter-setter' },
        viewModel: function (params) {
            var id = $.cdh.helper.getUniqueID('filter_setter_');
            var defaults = {
                id: id,
                title: 'Quick filter',
                setters: [{ text: 'All', setter: function () { } }],
                selectedTextObservable: ko.observable($.cdh.languageConstant.getConstant('filter.select-activities')),
                disableObservable: ko.observable(false)
            }

            $.extend(true, this, defaults, params);

            touchFiendlyToggle.call(this);

            this.afterRender = function(){
                $.cdh.helper.addKeyboardNavToMenu('#' + id + '__menu', 'li>span');
                var $menu = $('#' + id + '__menu');

                this.opened.subscribe(function (isOpened) {
                    var $elToFocus;
                    var $activeOption = $menu.find('li[aria-selected="true"]');
                    var $fallbackOption = $menu.find('li').first();
                    var $needleOption = $activeOption.length > 0 ? $activeOption : $fallbackOption;
                    if(isOpened) {
                        $elToFocus = $needleOption.find('> span');
                    } else {
                        $elToFocus = $('#' + id + '__value_btn');
                    }

                    $elToFocus.trigger('focus');
                });

                $menu.on('exit', () => {
                    this.opened(!this.opened());
                });

            }.bind(this);

        }
    });

    ko.components.register('html-dropdown', {
        template: { element: 'template-html-dropdown' },
        viewModel: function (params) {
            var defaults = {
                options: [], // required
                optionsText: '', // required
                optionsCaption: '',
                value: ko.observable(),
                disable: false,
            }
            const self = this;
            this.dropdownId = 'dropdownID_' + Math.random().toString(16).slice(2);

            $.extend(true, this, defaults, params);

            this.selectedText = ko.pureComputed(function () {
                return this.value()
                    ? this.value()[this.optionsText]
                    : this.optionsCaption;
            }, this);

            touchFiendlyToggle.call(this);

            this.keyboardHandler = function (data, e) {
                if (e.keyCode === 9) { // Tab
                    this.opened(false);
                }
                if (e.keyCode === 13 || e.keyCode === 32) { // Enter - Space
                    const container = $(e.target).closest('html-dropdown')[0];
                    const items = container.querySelectorAll('.select-dropdown ul > li');
                    this.toggleClick();
                    items[0].setAttribute('tabindex', '0');
                    items[0].focus();

                    return false;
                }

                return true;
            };

            this.listKeyboardHandler = function (data, e) {
                if (e.keyCode === 27) { // Esc
                    self.opened(false);
                    const container = $(e.target).closest('html-dropdown')[0];
                    removeAvailables(container);
                    const button = container.querySelector('.select-text');
                    if (button) {
                        button.focus();
                    }
                }

                if (e.keyCode === 38 || e.keyCode === 40) {
                    const container = $(e.target).closest('html-dropdown')[0];
                    const items = container.querySelectorAll('.select-dropdown ul > li');
                    let nextIndex;
                    let currentKey;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].hasAttribute('tabindex') && items[i].getAttribute('tabindex') == '0') {
                            nextIndex = currentKey = i;
                            break;
                        }
                    }

                    if (e.keyCode === 38) {
                        nextIndex--;
                    } else if (e.keyCode === 40) {
                        nextIndex++;
                    }

                    if (items[nextIndex]) {
                        items[currentKey].setAttribute('tabindex', '-1');
                        items[nextIndex].setAttribute('tabindex', '0');
                        items[nextIndex].focus();
                    } else {
                        return false;
                    }
                }
            };

            this.itemKeybordHandler = function (data, e) {
                if (e.keyCode === 13 || e.keyCode === 32) { // Enter - Space
                    if (e.target.classList.contains('link-icon')) {
                        e.target.click();
                        return false;
                    }
                    e.stopPropagation();
                    self.opened(false);
                    self.value(this);
                    const container = $(e.target).closest('html-dropdown')[0];
                    removeAvailables(container);
                    const button = container.querySelector('.select-text');
                    if (button) {
                        button.focus();
                    }

                    return false;
                }

                if (e.keyCode === 9) { // Tab
                    if (e.target.classList.contains('link-icon')) {
                        self.opened(false);
                        const container = $(e.target).closest('html-dropdown')[0];
                        removeAvailables(container);

                        const $currentRow = $(e.target).parents('.popup-row');
                        if (!$currentRow.length) return;

                        const $nextRow = $currentRow.next('.popup-row');
                        if (!$nextRow.length) return;

                        const $formElements = $nextRow.eq(0).find('input, select, button');
                        if (!$formElements.length) return;

                        $formElements[0].focus();
                    } else {
                        e.stopPropagation();
                        e.preventDefault();
                        const link = e.target.querySelector('a');
                        if (link) {
                            link.focus();
                        }
                    }
                }

                return true;
            };

            function removeAvailables(container) {
                const selectedItems = container.querySelectorAll('.select-dropdown ul > li[tabindex="0"]');
                if (selectedItems.length) {
                    selectedItems.forEach(function (item) {
                        item.setAttribute('tabindex', '-1');
                    })
                }
            }
        }
    });

    ko.components.register('icon-hint', {
        template:
            "<span class='icon-view' data-bind='css: { opened: opened }, event: { mouseover: onMouseOver, mouseout: onMouseOut }'>" +
            "<button type='button' class='icon-view_btn' aria-label='full account number' data-bind='event: { focus: onMouseOver, blur: onMouseOut }, click: toggleClick, attr: { \"aria-describedby\": id, \"aria-expanded\": opened().toString() }'></button>" +
            "<span class='icon-view_hint' data-bind='text: hintText, attr: { id: id }' role='tooltip'></span>" +
            "</span>",
        viewModel: function (params) {
            this.hintText = params.text;
            this.id = 'icon_view_tooltip_' + Math.random();
            const self = this;
            touchFiendlyToggle.call(this);
            $(window).keyup(function(e) {
                if (e.keyCode === 27) {
                    self.opened(false);
                }
            });
        }
    });


    function htmlWidgetModel(afterRender, template) {

        this.afterRender = afterRender || function(renderedNodesArray, $data) {};

        this.template = template;
        if (this.template && this.template.customFields && this.template.customFields.length > 0 && $.cdh.user.languagePreference != 'en') {
            this.template.customFields.forEach(w => {
                if (w.value.includes('External2')) {
                    w.value = w.value.replace("External2", "External2_" + $.cdh.user.languagePreference);
                }
            });

        }
        this.templateExtractor = new $.cdh.services.templateExtractor(template);

        this.getLabel = function (name, value) {
            return this.templateExtractor.getLabel(name, value);
        }.bind(this);

        this.getTemplate = function (name, value) {
            return this.templateExtractor.getTemplate(name, value);
        }.bind(this);
    }

    var registerHtmlWidget = function (componentName, afterRender) {
        ko.components.register(componentName, {
            template: "<!-- ko template: { name: 'template-" + componentName + "', afterRender: afterRender } --><!-- /ko -->",
            viewModel: {
                createViewModel: function (params, componentInfo) {
                    var updateHeight = updateContainerHeight(componentInfo.element);
                    setInterval(updateHeight, 400);

                    return new htmlWidgetModel(afterRender, params.template);
                }
            }
        });
    }

    $.extend(true, $, {
        cdh: {
            registerHtmlWidget: registerHtmlWidget
        }
    });

    var captchaComponentIncrementalId = 1;
    ko.components.register('captcha',
        {
            template: "<!-- ko template: {name: 'template-captcha', afterRender: afterRender} --><!-- /ko -->",
            viewModel: function(params) {
                this.componentId = "captcha-" + (++captchaComponentIncrementalId);
                this.sitekey = null;
                this.widgetId = null;

                this.initialize = function(sitekey) {
                    this.sitekey = sitekey;
                    return this.componentId;
                }.bind(this);

                this.initializeRecaptcha = function(){
                    recaptchaStatus.awaitLoad(function() {
                        var $target = $('<div />').appendTo($('#'+this.componentId));
                        this.widgetId = grecaptcha.render($target[0],
                            {
                                sitekey: this.sitekey,
                                callback: params.callback
                            });
                    }.bind(this));
                }.bind(this);

                this.afterRender = function() {
                    //create recaptcha script element
                    var recaptchaScript = document.createElement('script');
                    recaptchaScript.type = "text/javascript";
                    recaptchaScript.src = "https://www.google.com/recaptcha/api.js?onload=recaptchaOnLoadCallback&render=explicit";
                    recaptchaScript.setAttribute('defer','');
                    recaptchaScript.setAttribute('async','');

                    // Seems that onreadystatechange works better on IE 10 onload seems to fire incorrectly
                    if ("onreadystatechange" in recaptchaScript) {
                        recaptchaScript.onreadystatechange = function() {
                            if (/loaded|complete/.test(recaptchaScript.readyState)) {
                                this.initializeRecaptcha();
                            }
                        }.bind(this);
                    } else {
                        recaptchaScript.onload = this.initializeRecaptcha;
                    }

                    (document.getElementsByTagName('head')[0] || document.body).appendChild(recaptchaScript);
                }.bind(this);

                this.reset = function() {
                    grecaptcha.reset(this.widgetId);
                }.bind(this);

                params.api.reset = this.reset;
            }
        })

}(jQuery, ko));
